import React, { useEffect, useState, Fragment } from "react";
import ReactDOM from "react-dom";
import { useAppDispatch } from "./store.hooks";
import { useLocation } from "react-router-dom";
import {
  loginSelector,
  loadingLoginSelector,
  errorLoginSelector,
} from "./Slice";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { updateSettings, getSettingsSelector } from "../Settings/Slice";

interface Props {
  children?: React.ReactNode;
}

const Layout = ({ children }: Props) => {
  const location = useLocation();
  const authResponse = useSelector(loginSelector);
  const dispatch = useAppDispatch();


  useEffect(() => {
    if (location.pathname != "/customers") {
      const params: any = {};
      params.mainMachineSerialNo = null;
      params.customerID = null;
      params.machine = null;

        dispatch<any>(updateParams(params));

        const savedSettings = localStorage.getItem("settings_serviceview");
        if (savedSettings) {
            const parsedSettings = JSON.parse(savedSettings);
            let newSettings: any = {
                customerLayoutSession: "Tab Strip",
                machineLayoutSession: "Tab Strip",
            }
            if (parsedSettings != undefined) {
                if (parsedSettings.customerLayout != undefined) {
                    newSettings.customerLayoutSession = parsedSettings.customerLayout;
                    newSettings.customerLayout = parsedSettings.customerLayout;
                }
                if (parsedSettings.machineLayout != undefined) {
                    newSettings.machineLayoutSession = parsedSettings.machineLayout;
                    newSettings.machineLayout = parsedSettings.machineLayout;
                }
            }
            dispatch<any>(updateSettings(newSettings));
        }

        
    }
  }, [location.pathname]);

  return <Fragment>{children}</Fragment>;
};

export default Layout;
